export { ErrorModule } from './module.component';
